/** @format */

import {
  AbstractControl,
  FormGroup,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import moment from 'moment';
import { date_utils } from './date_utils';
import { MaxError, MinError } from './errors/error-messages';

//const isUpperCase = (string) => /^[A-Z]*$/.test(string);

const isUpperCase = (string: any) => /(?=.*[A-Z])/.test(string);
const isLowerCase = (string): any => /(?=.*[a-z])/.test(string);
const isNumber = (string: any) => /(?=.*[0-9])/.test(string);

const isPasswordSpecial = (string: any) =>
  /[!.,@#$%&*\(\)]/.test(string);
const isSpecial = (string: any) =>
  /(?=.*[!#$%&()*+,-./:;<=>?@^_~])/.test(string);
const validateNumber = (string: any) => /^([0-9-])+$/.test(string);

// const reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
export const URL_REGEX =
  // /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w\.-]*)*\/?$/g
  // /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&=]*)/g;
  // /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:\/?#[\]@!\$&'\(\)\*\+,;=.]+$/g;
  /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/;
export const EMAIL_REGEX =
  /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|rofil}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;

export class AppValidators {
  static isNumber(): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      let v = c.value;
      if (v == null || v == '') return null;

      let vv = parseFloat(v);
      if (isNaN(vv) || !validateNumber(v)) {
        return {
          number: {
            valid: false,
          },
        };
      }

      return null;
    };
  }
  static functional(ff: (v) => ValidationErrors | null): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      let v = c.value;
      if (v == null || v == '') return null;

      return ff(v);
    };
  }
  static nonzero(): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      let v = c.value;
      if (v == null || v == undefined) return null;
      if (typeof v == 'string') v = parseFloat(v);

      if (!v) return { nonzero: { valid: false } };

      return null;
    };
  }
  static min(min: number): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      let v = c.value;
      if (v == null || v == undefined) return null;
      if (typeof v == 'string') v = parseFloat(v);

      if (v < min)
        return {
          min: {
            min: min,
            actual: v,
          } as MinError,
        };

      return null;
    };
  }
  static above(min: number): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      let v = c.value;
      if (v == null || v == undefined) return null;
      if (typeof v == 'string') v = parseFloat(v);

      if (v <= min)
        return {
          above: {
            min: min,
            actual: v,
          } as MinError,
        };

      return null;
    };
  }
  static below(max: number): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      let v = c.value;
      if (v == null || v == undefined) return null;

      if (typeof v == 'string') v = parseFloat(v);

      if (v >= max)
        return {
          below: {
            max: max,
            actual: v,
          } as MaxError,
        };

      return null;
    };
  }

  ////////////////////////////////////////////////
  ////////////////////////////////////////////////
  ////////////////////////////////////////////////
  // date Validators
  static future(offset?: number): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      if (!c.value || c.value == '') return null;

      let v = c.value as moment.Moment;
      let now = moment().startOf('day');

      if (!v.isAfter(now)) return { date: { valid: false } };

      return null;
    };
  }
  static nowOrFuture(offset?: number): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      if (!c.value || c.value == '') return null;

      let v = c.value as moment.Moment;
      let now = moment().startOf('day');
      if (offset) now = now.clone().add(offset, 'day');

      if (!v.isSameOrAfter(now)) return { date: { valid: false } };

      return null;
    };
  }
  static dateRange(
    startName: string,
    endName: string,
    startField: string,
    endField: string,
    days?: number
  ): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      let start = c.value[startName];
      let end = c.value[endName];

      if (!start || !end) return null;


      {
        let ctl = (c as any).controls[startName];
        let errors = ctl.errors;
        if (errors) {
          delete errors.dateRange
          delete errors.dateRangeDays;
          if (Object.keys(errors).length == 0) errors = null
          ctl.setErrors(errors);
        }
      }
      let group = c as FormGroup


      let _end = moment(end);
      let _start = moment(start);
      if (end.isBefore(start)) {
        (c as any).controls[startName].setErrors({
          dateRange: {
            start: startField,
            end: endField,
          },
        });
        return {
          dateRange: {
            start: startField,
            end: endField,
          },
        };
      }
      if (days) {
        let _days = _end.diff(_start, 'days')
        if (_days > days) {
          group.controls[endName].markAsTouched()
          group.controls[endName].markAsDirty();
          group.controls[startName].setErrors({
            dateRangeDays: {
              start: startField,
              end: endField,
              days,

            },
          });
          return {
            dateRangeDays: {
              start: startField,
              end: endField,
              days,
            }
          }
        }
      }
      return null;
    };
  }

  static dateRangeTime(
    startName: string,
    endName: string,
    startField: string,
    endField: string
  ): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      let start = c.value[startName];
      let end = c.value[endName];
      let startTime = c.value[startName + 'Time'];
      let endTime = c.value[endName + 'Time'];

      if (!start || !end) return null;
      let group = c as FormGroup


      {
        let ctl = (c as any).controls[startName];
        let errors = ctl.errors;
        if (errors) {
          delete errors.dateRange
          if (Object.keys(errors).length == 0) errors = null
          ctl.setErrors(errors);
        }
      }
      let _start = date_utils.combineTimeLocal(
        start,
        startTime
      );
      let _end = date_utils.combineTimeLocal(
        end,
        endTime
      );
      if (_end.isBefore(_start)) {
        group.controls[endName].markAsTouched()
        group.controls[endName].markAsDirty();
        group.controls[startName].setErrors({
          dateRange: {
            start: startField,
            end: endField,
          },
        });
        return {
          dateRange: {
            start: startField,
            end: endField,
          },
        };
      }
      return null;
    };
  }

  static numbersLessThanEquals(
    startName: string,
    endName: string,
    startField: string,
    endField: string
  ): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      let start = c.value[startName];
      let end = c.value[endName];

      if (start == null || end == null) return null;


      let group = c as FormGroup
      {
        let ctl = group.controls[endName];
        let errors = ctl.errors;
        if (errors) {
          delete errors['numbersLessThanEquals']
          if (Object.keys(errors).length == 0) errors = null
          ctl.setErrors(errors);
        }
      }


      if (end < start) {
        group.controls[endName].markAsTouched()
        group.controls[endName].markAsDirty()

        group.controls[endName].setErrors({
          numbersLessThanEquals: {
            start: startField,
            end: endField,
          },
        });
        return {
          numbersLessThanEquals: {
            start: startField,
            end: endField,
          },
        };
      }



      return null;
    };
  }
  static numbersLessThan(
    startName: string,
    endName: string,
    startField: string,
    endField: string
  ): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      let start = c.value[startName];
      let end = c.value[endName];

      if (start == null || end == null) return null;


      let group = c as FormGroup
      {
        let ctl = group.controls[endName];
        let errors = ctl.errors;
        if (errors) {
          delete errors['numbersLessThan']
          if (Object.keys(errors).length == 0) errors = null
          ctl.setErrors(errors);
        }
      }


      if (end <= start) {
        group.controls[endName].markAsTouched()
        group.controls[endName].markAsDirty()
        group.controls[endName].setErrors({
          numbersLessThan: {
            start: startField,
            end: endField,
          },
        });
        return {
          numbersLessThan: {
            start: startField,
            end: endField,
          },
        };
      }



      return null;
    };
  }



  static email(c: AbstractControl): ValidationErrors | null {
    const v = c.value;
    if (!v || v == '') return null;
    if (!EMAIL_REGEX.test(v)) {
      return { email: { valid: false } };
    }

    return null;
  }
  // }
}

// export function validateUrl(): ValidatorFn {

export let validateUrl = (c: AbstractControl): ValidationErrors | null => {
  const v = c.value;
  if (!v || v == '') return null;
  if (v.indexOf('://') < 0) {
    return { url: { valid: false } };
  }

  return null;
};
// }

export function validatePassword(
  length: number,
  pattern: string,
  patternTypes?: number
): ValidatorFn {
  return (c: AbstractControl): ValidationErrors | null => {
    const v = c.value;
    if (v.length < length)
      return { password: { valid: false, length, pattern, patternTypes } };

    if (patternTypes) {
      let count = 0;
      if (pattern.indexOf('a') >= 0)
        if (isLowerCase(v)) {
          count++;
        }
      if (pattern.indexOf('A') >= 0)
        if (isUpperCase(v)) {
          count++;
        }
      if (pattern.indexOf('1') >= 0 || pattern.indexOf('0') >= 0)
        if (isNumber(v)) {
          count++;
        }
      if (pattern.indexOf('@') >= 0)
        if (isPasswordSpecial(v)) {
          count++;
        }

      if (count < patternTypes)
        return { password: { valid: false, length, pattern, patternTypes } };
    } else {
      if (pattern.indexOf('a') >= 0)
        if (!isLowerCase(v)) {
          return { password: { valid: false, length, pattern, patternTypes } };
        }
      if (pattern.indexOf('A') >= 0)
        if (!isUpperCase(v)) {
          return { password: { valid: false, length, pattern, patternTypes } };
        }
      if (pattern.indexOf('1') >= 0 || pattern.indexOf('0') >= 0)
        if (!isNumber(v)) {
          return { password: { valid: false, length, pattern, patternTypes } };
        }
      if (pattern.indexOf('@') >= 0)
        if (!isPasswordSpecial(v)) {
          return { password: { valid: false, length, pattern, patternTypes } };
        }
    }
    return null;
  };
}

export function validateMatchPasswords(group: UntypedFormGroup) {
  // here we have the 'passwords' group
  let ff = group.controls['password2'];
  const pass = group.controls['password'].value;
  const confirmPass = ff.value;

  let err = ff.errors;
  if (err) delete err['passwordNotMatched'];
  if (pass === confirmPass) {
    ff.setErrors(err);
    ff.updateValueAndValidity({
      onlySelf: true,
    });
    return null;
  }

  ff.setErrors({ passwordNotMatched: true });
  return { passwordNotMatched: true };
}

export function validateLength(lens: number[]) {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as string;
    if (!value) return null;

    const length = value.length;
    if (!lens.includes(length)) {
      return { length: true, lens: lens };
    }
    return null;
  };
}
